module.exports = __webpack_public_path__ + "img/项目产品管理.4135e333.svg";